import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Layout from "../../layouts/auth.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
let SystemoneRegistrationSuccess = /** @class */ (() => {
    let SystemoneRegistrationSuccess = class SystemoneRegistrationSuccess extends Mixins(BaseMixer) {
    };
    SystemoneRegistrationSuccess = __decorate([
        Component({
            name: "SystemoneRegistrationSuccess",
            components: {
                Layout,
                PageHeader,
            },
        })
    ], SystemoneRegistrationSuccess);
    return SystemoneRegistrationSuccess;
})();
export default SystemoneRegistrationSuccess;
